import React, { useEffect, useRef } from "react";
import dynamic from "next/dynamic";
const Lottie = dynamic(() => import("lottie-react"), { ssr: false });

interface LottieAnimationProps {
  animationData: any;
  width?: string;
  height?: string;
  mountAnimation?: boolean;
  unmountAnimation?: boolean;
  loop?: boolean;
  autoplay?: boolean;
  onComplete?: () => void;
}

const LottieAnimation: React.FC<LottieAnimationProps> = ({
  animationData,
  width = "100%",
  height = "100%",
  mountAnimation = true,
  unmountAnimation = true,
  loop = false,
  autoplay = true,
  onComplete,
}) => {
  const lottieRef = useRef<any>(null);

  useEffect(() => {
    const instance = lottieRef.current?.getLottie();
    if (instance) {
      instance.loop = loop;
      if (autoplay) {
        instance.play();
      }
      if (onComplete) {
        instance.addEventListener("complete", onComplete);
      }
    }

    return () => {
      if (unmountAnimation && instance) {
        // 卸载时停止播放动画
        instance.stop();
      }
      if (instance && onComplete) {
        instance.removeEventListener("complete", onComplete);
      }
    };
  }, [mountAnimation, unmountAnimation, loop, autoplay, onComplete]);

  return (
    <Lottie
      // ref={lottieRef}
      loop={loop}
      autoplay={autoplay}
      onComplete={onComplete}
      animationData={animationData}
      style={{ width, height }}
    />
  );
};

export default LottieAnimation;
